import type { Organization } from "@/models/organization"
import type { User } from "@/models/user"
import type { SuccessData } from "@/utils/api"
import { httpClient } from "@/utils/api"
import type { UseMutationOptions } from "@tanstack/react-query"
import type { AxiosError, AxiosResponse } from "axios"

import type { UserMutationError } from "./use-user-mutation"
import { useUserMutation } from "./use-user-mutation"

interface AddExistingUserToOrganizationInput {
  organizationId: Organization["id"]
  userId: User["id"]
}

export type AddExistingUserToOrganizationError = UserMutationError

const addExistingUserToOrganizationApi = async ({
  organizationId,
  userId,
}: AddExistingUserToOrganizationInput): Promise<AxiosResponse<SuccessData>> => {
  return httpClient.post<SuccessData>(
    "/api/v1/users/add_existing_to_organization",
    {
      organization_id: organizationId,
      user_id: userId,
    }
  )
}

export const useAddExistingUserToOrganization = (
  options: UseMutationOptions<
    AxiosResponse<SuccessData>,
    AxiosError<AddExistingUserToOrganizationError>,
    AddExistingUserToOrganizationInput
  > = {}
) =>
  useUserMutation({
    mutationFn: addExistingUserToOrganizationApi,
    resultKey: "addExistingUserToOrganization",
    fallbackErrorMessage: "addExistingUserToOrganization.addUserError",
    options,
  })
